module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kVKAd"))).then(() => parcelRequire('hEqeo'));